import { render, staticRenderFns } from "./TournamentsList.vue?vue&type=template&id=6babecf3&lang=pug"
import script from "./TournamentsList.vue?vue&type=script&lang=js"
export * from "./TournamentsList.vue?vue&type=script&lang=js"
import style0 from "./TournamentsList.vue?vue&type=style&index=0&id=6babecf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports